import { getEditor } from './../editors';
import { getRenderer } from './../renderers';
var CELL_TYPE = 'handsontable';
export default {
  editor: getEditor(CELL_TYPE),
  // displays small gray arrow on right side of the cell
  renderer: getRenderer('autocomplete')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/cellTypes/handsontableType.js
// module id = 1891
// module chunks = 0